import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import FilterComp from "../../common/filter-comp.vue";
import DisplayTextData from "@/components/common/display-text-data.vue";
import ReadOnlyDialog from "@/components/common/read-only-dialog.vue";
import receiveService from "./receive-srvice";
import utility from "@/shared/utility";
import ChangeLpn from "../change-lpn-comp.vue";
import CommonDialog from "@/components/common/common-dialog.vue";
import RouteDiscrepancyComp from "../route-discrepancy-comp.vue";
export default {
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      favouriteList: [],
      lpnData: {},
      mainPage: "",
      subPage: "",
      backSlash: true,
      projectName:"",
      orderNum:"",
      ord_key:"",
      showDiscrepancyDialog:false,
      pageUrl: "",
      showAdd: false,
      pageNumber: 1,
      activeField:null,
      searchType: "",
      showTable: true,
      labelValue:false,
      tableData: [],
      lpnObj:{},
      receiveType: "",
      showDialog:false, 
      message:"",
      textSearch: "",
      poObj: {
        UserId: this.userId,
        DiscrepancyTag:"",
        ProjKey: "",
        PartNum: "",
        Vendor: "",
        show_closed: "",
        PageNumber: 1,
      },
      soObj: {
        UserId: this.userId,
        ProjKey: "",
        RITM: "",
        RequestNumber: "",
        SerialNo: "",
        Waybill: "",
        show_closed: "",
        DiscrepancyTag:"",
        PageNumber: 1
      },
      totalRecords: 0,
      showDetails: true,
      showChangeLpn:false,
      dialogType:"",
      max50Rule: [ (v) => (v || "").length <= 50 || "Max Length of 50 character"],
      min3Rule: [
        (v) =>
          (v || "").length >= 3 || "Min Length must be 3 characters or More",
      ],
      displayArrayData: [""],
      salesOrderHeader: [
        {
          text: "SO#",
          value: "sono",
          class: "primary customwhite--text",
        },
        {
          text: "RMA",
          value: "rma",
          class: "primary customwhite--text",
        },
        {
          text: "Order Type",
          value: "order_type",
          class: "primary customwhite--text",
        },
        {
          text: "Open Qty",
          value: "open_qty",
          class: "primary customwhite--text",
        },
        {
          text: "Company",
          value: "company",
          class: "primary customwhite--text",
        },
        {
          text: "Search Result",
          value: "search_results",
          class: "primary customwhite--text",
        },
        {
          text: "Order Date",
          value: "order_date",
          class: "primary customwhite--text",
        },
        {
          text: "Actions",
          value: "actions",
          class: "primary customwhite--text",
        },
      ],
      purchaseOrderHeader: [
        {
          text: "PO#",
          value: "purno",
          class: "primary customwhite--text",
        },
        {
          text: "RMA",
          value: "rma",
          class: "primary customwhite--text",
        },
        {
          text: "Order Type",
          value: "order_type",
          class: "primary customwhite--text",
        },
        {
          text: "Open Qty",
          value: "open_qty",
          class: "primary customwhite--text",
        },
        {
          text: "Vendor",
          value: "vendor",
          class: "primary customwhite--text",
        },
        {
          text: "Search Result",
          value: "search_results",
          class: "primary customwhite--text",
        },
        {
          text: "Order Date",
          value: "order_date",
          class: "primary customwhite--text",
        },
        {
          text: "Actions",
          value: "actions",
          class: "primary customwhite--text",
        },
      ],
      pageCount: 0,
      showReceiveLPN: false,
      showReceiveStaging: false,
      showReceiveStagingVal: "",
      showLpnVal: "",
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    this.receiveType = this.$route.path.replace("/", "")?.split("/")[1];
    let data = await AddFavourite.getPageAction(this.userId, "receiving");
    this.actionList = data.actionList;
    if (this.receiveType === "SO" || this.receiveType === "PO") {
      this.mainPage = "Receiving";
      this.favouriteList = data.favouriteList;
      this.pageUrl = "receiving";
      this.subPage = `${this.receiveType} Receiving`;
    }
  },
  computed: {
  },

  mounted() {
    this.lpnObj = JSON.parse(
      EncryptUtility.localStorageDecrypt("receivelpnDetails")
    );
    if (this.lpnObj) {
      Object.assign(this, {
        showReceiveLPN: !!this.lpnObj.lpn,
        showLpnVal: this.lpnObj.lpn || "",
        showReceiveStaging: !!this.lpnObj.bin,
        showReceiveStagingVal: this.lpnObj.bin || "",
      });
      this.showDetails=true
      this.displayArrayData=[
        {label:"Project",value:this.lpnObj.projectName},
      ]
      this.projectName=this.lpnObj.projectName
    }
    
  },
  methods: {
    handleInput(fieldNumber) {
      let obj=""
      obj = this.receiveType=="SO"? this.soObj[fieldNumber]: this.poObj[fieldNumber]
      // If the field has a value, set it as active
      if (obj) {
        this.activeField = fieldNumber;
      } else {
        // If field is cleared, enable all fields
        this.activeField = null;
      }
    },
    isDisabled(fieldNumber) {
      // Disable if another field is active
      return this.activeField !== null && this.activeField !== fieldNumber;
    },
    actionSetter(permission) {
      return utility.actionSetter(this.actionList, permission);
    },
    async fetchOrders(searchType, pageNum = 1) {
      this.searchType = searchType;
      let requestObj;
      if (searchType === "search") {
        requestObj = {
          UserId: this.userId,
          SearchStr: this.textSearch,
          projKey: this.lpnObj.proj_key,
          show_closed: this.includeClosed ? 1 : 0,
          PageNumber: pageNum,
        };
      } else {
        requestObj = this.receiveType === "SO" ? this.soObj : this.poObj;
        requestObj.userId = this.userId;
        requestObj.ProjKey = this.lpnObj.proj_key;
        requestObj.show_closed = this.includeClosed ? 1 : 0;
        requestObj.PageNumber = pageNum;
      }

      let serviceMethod =
        searchType === "search"
          ? this.receiveType === "SO"
            ? receiveService.postSalesOrderSearch.bind(receiveService)
            : receiveService.postPurchaseOrderSearch.bind(receiveService)
          : this.receiveType === "SO"
          ? receiveService.postSalesOrderAdvance.bind(receiveService)
          : receiveService.postPurchaseOrderAdvance.bind(receiveService);
      let response = await serviceMethod("post", requestObj, false);
      this.showTable = true;
      this.tableData = response || [];
      if(!this.tableData.length==0){
      
      
      this.tableData?.forEach((element) => {
        element.order_date = utility.displayDateFormat(element.order_date);
      });
      if(response[0]?.TotalRecords==1 && this.actionSetter("ReceivingDetails")){
        this.onClickDetails(this.tableData)
      }
      
      this.totalRecords = response[0]?.TotalRecords;
      this.totalRecords==0?utility.showNoDataToast("No Result Found"):"";
      this.pageCount = response[0]?.TotalPages;
    }
    else{
      this.totalRecords = 0;
      this.pageCount = 0;
      this.tableData = [];
      utility.showNoDataToast("No Result Found")

    }
  },
   
    // Usage:
    async onClickSearch(pageNum) { 
      if(this.$refs.searchTagForm?.validate() ){
        this.onClickClear();
         this.saveToEncryptedStorage({
        soSearchObj: "",
        poSearchObj: "",
      });
      await this.fetchOrders("search", pageNum);
      }
    },
    async onClickFind(pageNum) {
      let formValidate=this.receiveType=="SO"?this.$refs.soFilterForm?.validate() :this.$refs.poFilterForm?.validate() ;
      if(formValidate){
        this.textSearch="";
        this.$refs.searchTagForm?.resetValidation();
      await this.fetchOrders("filter", pageNum);
      this.saveToEncryptedStorage({
        soSearchObj: this.soObj,
        poSearchObj: this.poObj
      });}
    },
     saveToEncryptedStorage(data) {
      console.log(data)
      Object.entries(data).forEach(([key, value]) => {
        EncryptUtility.localStorageEncrypt(key, JSON.stringify(value));
      });
    },
    onPageChange(pageNumber) {
      this.searchType == "filter"
        ? this.onClickFind(pageNumber)
        : this.onClickSearch(pageNumber);
    },
    onClickDetails(item){
      let itemList = Array.isArray(item) ? item[0] : item;
      const id=itemList.so_id?itemList.so_id:itemList.po_id
      this.$router.push(`/receiving-details/${this.receiveType}/${btoa(id?.toString())}`);
    },
    onClickReceiveStagingFunction(){
      this.$router.push(`/receiving/${this.receiveType}`)  
    },
    onClickReceiveLPNFunction(){
      this.showChangeLpn=true;
      this.dialogType="LPN"
    },
    receiveQuickVerificationFunction(){
      this.showChangeLpn=true;
      this.dialogType="Verify"
    },
    closeChangeLpnDialog(lpn){
      if(lpn){
      this.showLpnVal=lpn
      this.lpnObj.lpn=lpn
            EncryptUtility.localStorageEncrypt(
              "receivelpnDetails",
              JSON.stringify(this.lpnObj)
            );
          }
      this.showChangeLpn=false
  },
  onClickReceiveResetFunction(){
    this.showDialog=true;
    this.message=`Are you sure you want to close this receipt? You will lose any unsubmitted data`
  },
  onClickDialogOk(){
    this.showDialog=false;
    this.$router.push(`/receiving`)  

  },
  onClickDialogCancel(){
    this.showDialog=false;
  },
  closeDiscrepancyDialog(){
    this.showDiscrepancyDialog=false;
  },
  onClickRouteDiscrepancyFunction(){
    this.showDiscrepancyDialog=true;
  },
  onClickClear(){
    this.activeField = null;
    this.poObj= {
      UserId: this.userId,
      DiscrepancyTag:"",
      ProjKey: "",
      PartNum: "",
      Vendor: "",
      show_closed: "",
      PageNumber: 1,
    },
    this.soObj= {
      UserId: this.userId,
      ProjKey: "",
      RITM: "",
      RequestNumber: "",
      SerialNo: "",
      Waybill: "",
      show_closed: "",
      PageNumber: 1,
      DiscrepancyTag:"",
    }
  },
  },
  components: {
    breadcrumbComp,
    FilterComp,
    DisplayTextData,
    ReadOnlyDialog,
    ChangeLpn,
    CommonDialog,
    RouteDiscrepancyComp
  },
};
